import React, { useEffect, useState, useRef } from 'react';
import { AutoComplete } from 'antd';
import { Cartesian3, Math } from 'cesium';
import Select from './Select';
import { CloseOutlined, SearchOutlined } from '@ant-design/icons';
import ItemWrap from '../components/item-wrap';
import useProps from '../../_util/useProps';
import HighlightLayer from '../../highlight-layer/HighlightLayer';
import classnames from 'classnames';

/**
 * @description: 关闭按钮
 * @return {JSX.Element}
 */
export function CloseBtn({ style, onClick }) {
    return (
        <CloseOutlined
            className={classnames('cs-close-btn')}
            onClick={() => {
                onClick && onClick();
            }}
            style={style}
        />
    );
}

const Content = props => {
    const { options, placeholder, onClear, ...otherProps } = props;

    useEffect(() => {
        return () => {
            onClear && onClear();
        };
    }, []);

    return (
        <div className={classnames('cs-autoComplete')}>
            <AutoComplete
                placeholder={placeholder || '请输入'}
                options={options}
                style={{ width: 160 }}
                allowClear={false}
                dropdownClassName={classnames('cs-search-wrap')}
                autoFocus
                {...otherProps}
            />
            <CloseBtn style={{ marginLeft: '10px' }} onClick={onClear} />
        </div>
    );
};

const OPTIONS = [
    { value: 'layer', label: '地图要素' },
    { value: 'address', label: '兴趣点位' },
];

const MODE = 'select'; // 单个 single | 可选 select

export default function(props) {
    const { map } = useProps();

    const { placeholder, defaultType, mode = MODE } = props;
    const time = useRef(null);
    const [options, setOptions] = useState([]);
    const [value, setValue] = useState('');
    const [type, setType] = useState(defaultType || OPTIONS[0]?.value);

    const itemRef = useRef();
    const highlightLayer = useRef();

    useEffect(() => {
        highlightLayer.current = new HighlightLayer({ map });
        return () => {
            onClear();
        };
    }, []);

    // 地址查询
    const onSearch = searchText => {
        if (time.current) {
            clearTimeout(time.current);
        }

        if (searchText && map) {
            time.current = setTimeout(() => {
                map.getMapFeatureInfoByText &&
                    map.getMapFeatureInfoByText({ type, searchText }).then(res => {
                        if (res?.length) {
                            setOptions(res);
                        }
                    });
            }, 500);
        } else {
            setOptions([]);
        }
    };

    const onChange = _value => {
        setValue(_value);
    };

    const onSelect = (_value, e) => {
        if (!map) return;
        if (type === 'address') {
            if (e.lngLat) {
                let [longitude, latitude] = e.lngLat;
                map.camera.flyTo({
                    destination: Cartesian3.fromDegrees(longitude, latitude, 1000.0),
                    orientation: {
                        pitch: Math.toRadians(-88.0),
                        roll: 0.0,
                    },
                    duration: 2,
                });
            }
        } else if (type === 'layer') {
            if (e.feature) {
                map.showTemplate(e.feature);
            }
        }
        setValue(e.label);
    };

    const onClear = () => {
        if (value) {
            map.hideTemplate();
        }

        itemRef.current?.onVisibleChange && itemRef.current.onVisibleChange(false);
        setValue('');
        setOptions([]);
    };

    const onTypeChange = value => {
        setType(value);
        setValue('');
        setOptions([]);
    };

    const content = () => (
        <div className={classnames('cs-content')}>
            {mode === 'select' && (
                <Select
                    options={OPTIONS}
                    style={{ width: '80px' }}
                    size="big"
                    onSelect={onTypeChange}
                    value={type}
                />
            )}

            <Content
                placeholder={placeholder}
                value={value}
                options={options}
                onSearch={onSearch}
                onChange={onChange}
                onSelect={onSelect}
                onClear={onClear}
            />
        </div>
    );
    return (
        <ItemWrap content={content} ref={itemRef} destroyTooltipOnHide hideCloseBtn={true}>
            <SearchOutlined />
        </ItemWrap>
    );
}
